<template>
  <div class="container-fluid">
    <div class="form-row">
      <div class="col-12">
        <button
          type="button"
          class="btn btn-default btn-sm mb-4"
          @click="addNewCertificateBtn"
        >
          Add New Certificate
        </button>
      </div>
    </div>

    <div class="form-row">
      <div class="col-12">
        <certificate
          v-for="(certificate, index) in certificates"
          :key="certificate.id"
          v-model="certificates[index]"
          :value="certificate"
          :index="certificate.id"
          @remove-certificate="removeCertificate"
          @save-certificate="saveCertificate"
        />
      </div>
    </div>
    <v-dialog
      v-model="isAddCertificateModalOpen"
      max-width="1140px"
    >
      <v-card>
        <template #title>
          New Certificate
        </template>
        <v-divider />
        <div class="px-3 pb-4">
          <certificate
            v-model="newCertificate"
            @add-certificate="addCertificate"
          />
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="isSnackbarOpen"
      :timeout="3000"
      location="top right"
    >
      <v-alert
        color="#dfe8e8"
        :title="title"
        :text="message"
      />
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import Certificate from './certificate.vue';

export default {
  components: {
    Certificate,
  },
  data() {
    return {
      newCertificate: null,
      certificates: [],
      isAddCertificateModalOpen: false,
      isSnackbarOpen: false,
      message: '',
      title: '',
    };
  },

  async mounted() {
    const result = await axios.get('/api/certificates');
    this.certificates = result.data;
  },

  methods: {
    addNewCertificateBtn() {
      this.newCertificate = {};
      this.isAddCertificateModalOpen = true;
    },
    saveCertificate(certificate) {
      this.openSnackbar('Saved', certificate.name);
    },
    addCertificate(certificate) {
      this.certificates.unshift(certificate);
      this.isAddCertificateModalOpen = false;
      this.openSnackbar('Added', certificate.name);
    },
    removeCertificate(certificate) {
      this.certificates.splice(this.certificates.findIndex(item => item.id === certificate.id), 1);

      this.openSnackbar('Deleted', certificate.name);
    },
    openSnackbar(title, message) {
      this.isSnackbarOpen = true;
      this.title = title;
      this.message = message;
    },
  },
};
</script>
